import { QueryParams } from './useQueryGroups';

export const groupKeys = {
  all_groups: () => ['GROUPS'],
  groups: (params?: QueryParams) => ['GROUPS', params] as const,
  single_group: (groupId: string) => ['SINGLE_GROUP', groupId],
};
